exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table tr:first-child td[data-v-8e7acd6c] {\n  border-top: none;\n}\n.table td[data-v-8e7acd6c] {\n  padding-left: 0px !important;\n}\n", ""]);

// exports
